// extracted by mini-css-extract-plugin
export default {"truncateBranch":"PullRequestHeaderSummary-module__truncateBranch--bdsQu"};